import { observer } from 'mobx-react';
import { storeKrunica } from '../../store/KrunicaStore';

function SlikaRitaNaslovna() {
  const { aktivnaZemlja, trenutnaKrunica } = storeKrunica;
  const { krunice } = aktivnaZemlja;

  // console.log(krunice);

  return (
    <div className="card">
      <div className="card__side card__side--front">
        <div className="card__picture card__picture--rita"></div>
        <h4 className="card__heading">
          <span className="card__heading-span card__heading-span--1">
            {krunice.find((k) => k.value === trenutnaKrunica)?.label}
          </span>
        </h4>
        <div className="card__details">
          <ul>
            <li>{krunice.find((k) => k.value === trenutnaKrunica)?.pozdrav}</li>
          </ul>
        </div>
      </div>
      <div className="card__side card__side--back card__side--back-1 ">
        <div className="card__cta">
          <div>{krunice.find((k) => k.value === trenutnaKrunica)?.opis}</div>
          <div className="autor">alenskupnjak@yahoo.com</div>
          <div className="git">
            https://github.com/alenskupnjak/reactKrunica
          </div>
        </div>
      </div>
    </div>
  );
}

export default observer(SlikaRitaNaslovna);
